import { createType } from 'framework/utils/createType';

export const StereoMonoContralateralTypes = createType('stereo', 'mono', 'contraLateral');
export type StereoMonoContralateralType = typeof StereoMonoContralateralTypes[number];
